import api from 'Application/api/api';

const makeBiddingOnOffer = (signal, values) =>
	api.post('/epc-offers/partner/make-bidding', values, {
		signal,
		timeout: 100000,
	});

export default makeBiddingOnOffer;
